import React, { useEffect, useState } from 'react';
import {Link} from "react-router-dom"
import './Users.css'; // Import CSS file
import Loaderdots from '../../components/LoaderDots/Loaderdots';
import { toast } from 'react-toastify';

const Users = () => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalPages, setTotalPages] = useState(1); // Track total pages (this should come from the API)
  const [isNextPage, setIsNextPage] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalUsers,setTotaluser] = useState(0)
  // useEffect(() => {
  //   const fetchUsersData = async () => {
  //     try {
  //       const response = await fetch(`https://admin.riymay.com/api/v1/admin/all/users/info?page=${currentPage}`);
  //       if (!response.ok) {
  //         throw new Error('Failed to fetch data');
  //       }
  //       const data = await response.json();
  //       setUsersData(data.users); // Assuming the user data is inside `usersData`
  //       setTotalPages(data.totalPages); // Assuming the total pages info is returned
  //       setIsNextPage(data.nextPage);
  //     } catch (err) {
  //       setError(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchUsersData();
  // }, [currentPage]);

  useEffect(()=>{
    const fetchUsersData = async () => {
      try {
        const token = localStorage.getItem('admintoken'); // Retrieve the token from localStorage

        const response = await fetch(`https://admin.riymay.com/api/v1/admin/user/search?query=${searchQuery}&page=${currentPage}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json', // Specify the content type
                'Authorization': `Bearer ${token}`, // Add the Bearer token
            },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        setUsersData(data.users); // Assuming the user data is inside `usersData`
        setTotalPages(data.totalPages); // Assuming the total pages info is returned
        setIsNextPage(data.nextPage);
        setTotaluser(data.totalUsers)
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersData()
  },[searchQuery,currentPage])
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleNextPage = () => {
      setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
 
  if (loading) {
    return <div>
      <Loaderdots />
      </div>;
  }

  if (error) {
    toast.error("Something went wrong! Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
    });
  }
  

  return (
    <div className="table-container overflo">
       <div className="orders-header">
          <div className="search-bar-container">
          <h3>User history</h3>

        <input
          type="text"
          placeholder="Search users..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="search-bar"
        />
      <div>
        <button  className='total-users'>total users: {totalUsers}</button>
      </div>
     </div>
        </div>
    
      <div className="admin-user-table-container">
  <div className="admin-user-table">
    {/* Headers */}
    <div className="admin-user-row header">
      <div>Email</div>
      <div>Name</div>
      <div>Phone</div>
      <div>Created At</div>
    </div>
    {/* Data */}
    <div className="admin-user-row data">
      {usersData?.map((user) => (
                  <React.Fragment key={user._id}>
                            <Link to={`/user/${user._id}/orders`}>
                            <div>{user.email}</div></Link>
                            <Link to={`/user/${user._id}/orders`}>
                            <div>{user.firstName} {user.lastName}</div></Link>
          <div>{user.phone}</div>
          <div>{new Date(user.createdAt).toLocaleString()}</div>
          </React.Fragment>
      ))}
    </div>
  </div>
</div>

      <div className="pagination-controls">
        <button onClick={handlePreviousPage} disabled={currentPage === 1} className="pagination-btn">
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button onClick={handleNextPage} disabled={!isNextPage} className="pagination-btn">
          Next
        </button>
      </div>
    </div>
  );
};

export default Users;
